/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import Axios from 'axios';
import {assign} from 'xstate';

import {ExtJS, Utils} from '@sonatype/nexus-ui-plugin';

import UIStrings from '../../../../constants/UIStrings';

const {ERROR, SAML_CONFIGURATION} = UIStrings;

export default Utils.buildFormMachine({
  id: 'SamlConfigurationForm'
}).withConfig({
  actions: {
    setData: assign({
      data: (_, {data}) => mapSamlResponse(data),
      pristineData: (_, {data}) => mapSamlResponse(data)
    }),

    logSaveError: (_, event) => {
      const error = event.data.data;
      if (error) {
        console.error(error);
      }
      ExtJS.showErrorMessage(SAML_CONFIGURATION.MESSAGES.SAVE_ERROR);
    },
    logSaveSuccess: () => ExtJS.showSuccessMessage(SAML_CONFIGURATION.MESSAGES.SAVE_SUCCESS),

    logLoadError: (_, event) => {
      const error = event.data.data;
      if (error) {
        console.error(error);
      }
      ExtJS.showErrorMessage(SAML_CONFIGURATION.MESSAGES.LOAD_ERROR);
    },

    validate: assign({
      validationErrors: ({data}) => ({
        idpMetadata: Utils.isBlank(data?.idpMetadata) ? ERROR.FIELD_REQUIRED : null,
        entityIdUri: Utils.notUri(data?.entityIdUri) ? SAML_CONFIGURATION.FIELDS.entityIdUriValidationError : null,
        usernameAttr: Utils.isBlank(data?.usernameAttr) ? ERROR.FIELD_REQUIRED : null
      })
    })
  },
  services:
      {
        fetchData: () => Axios.get('/service/rest/internal/ui/saml'),
        saveData: ({data}) => {
          return Axios.put('/service/rest/internal/ui/saml', {
            ...data,
            validateResponseSignature: data.validateResponseSignature === 'default' ? null : data.validateResponseSignature,
            validateAssertionSignature: data.validateAssertionSignature === 'default' ? null : data.validateAssertionSignature
          });
        }
      }
});

/**
 * Returns a modified data object where Boolean properties validateResponseSignature and validateAssertionSignature are
 * handled as strings
 */
function mapSamlResponse({data}) {
  ['validateResponseSignature', 'validateAssertionSignature'].forEach(function(item) {
    data[item] = data[item] === null ? 'default' : data[item].toString();
  });
  return data;
}
